import { Column, ColumnType, DeleteRow, Row } from '~components/table-view';

import { AccessTag } from '~support-at-home/actions/accessTags';

export const columnsFactory = (
  tags: AccessTag[],
  onDelete: (row: Row) => void,
  isAdmin: boolean,
  explicitOnly: string[] = [],
): Column[] => [
  {
    id: 'full_name',
    header: 'Name',
    type: 'text',
  },
  ...tags.map((tag, index) => ({
    id: `${tag.id}-${tag.permission}-${index}`,
    header: tag.permission,
    type: 'checkbox' as ColumnType,
    width: '120px',
    deriveValue: (row: Row) =>
      row?.tags?.some((t: any) => t.tag_id === tag.id) ||
      (!explicitOnly.includes(tag.permission) && !row.editable),
  })),
  {
    id: 'delete-button',
    header: '',
    type: 'custom',
    style: { width: '50px' },
    component: DeleteRow,
    componentProps: {
      onDelete,
      tooltip: 'Remove access tags',
      disabled: (row: Row) => !isAdmin || !row.editable,
    },
  },
];
